import React from 'react';
import CaseStudyPage from '../CaseStudyPage';
import { caseStudies } from '../../../data/caseStudies';

export const USAIDPage = () => <CaseStudyPage study={caseStudies.USAID} />;
export const DCMAPage = () => <CaseStudyPage study={caseStudies.DCMA} />;
export const NASSPage = () => <CaseStudyPage study={caseStudies.NASS} />;
export const FNSPage = () => <CaseStudyPage study={caseStudies.FNS} />;
export const SFFWPage = () => <CaseStudyPage study={caseStudies.SFFW} />;
export const MCCLEPPage = () => <CaseStudyPage study={caseStudies.MCCLEP} />;
export const LEPage = () => <CaseStudyPage study={caseStudies.LE} />;
export const ASPage = () => <CaseStudyPage study={caseStudies.AS} />;
export const DeloitteAI = () => <CaseStudyPage study={caseStudies.DeloitteAI} />;
export const CASCADEPage = () => <CaseStudyPage study={caseStudies.CASCADE} />;
